import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe, CommonModule } from '@angular/common';
import { ModalSize } from '@signal/component-library/efx-modal';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
// Asegúrate de importar la interfaz correcta
import { IDomainVerify } from "./../../../interfaces/pages/abm/domain-verify.interface";
import { EnumAbmBuscadorFlow } from 'src/app/enums/shared/abm-buscador-enum';
import { ITableSearchConfig } from "./../../../interfaces/pages/abm/abm-buscador.interface";
import { LocalStorageService } from 'src/app/services/shared/local-storage/local-storage.service';
import { Country } from 'src/app/entities/shared/Country';
import { SignalDesignModule } from 'src/app/signal-design/signal-design.module';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TablaDinamicaBuscadorComponent } from '../tabla-dinamica-buscador/tabla-dinamica-buscador.component';

@Component({
  selector: 'app-modal-abm-buscador-settings',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AsyncPipe,
    SignalDesignModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    TablaDinamicaBuscadorComponent
  ],
  templateUrl: './modal-abm-buscador-settings.component.html',
  styleUrl: './modal-abm-buscador-settings.component.scss'
})
export class ModalAbmBuscadorSettingsComponent implements OnInit, OnChanges {
  modalSize = ModalSize;
  private readonly defaultPurposingPayload = `{}`;
  private readonly helpTexts: Record<string, string> = {
    searchSourceType: 'Define si el buscador consultará una fuente de Journaling tradicional o una fuente orientada a Propósito.',
    domain: 'Corresponde al dominio funcional de la fuente. Para búsquedas de Propósito este valor también se usa como dominio de consulta.',
    subDomain: 'Corresponde al subdominio o fuente específica que se mostrará y consultará en la búsqueda.',
    purposingProfile: 'Indica el perfil o esquema de Propósito sobre el cual se ejecutará la búsqueda.',
    order: 'Controla la posición en la que este buscador aparecerá dentro de la lista de opciones.',
    labelDropDown: 'Es el nombre visible que verá el usuario en el selector del buscador.',
    profile: 'Define si la búsqueda está orientada a persona, empresa u otro tipo de entidad.',
    profileBusqueda: 'Identifica el perfil de búsqueda que utilizará la fuente para resolver la consulta.',
    identifyType: 'Indica el tipo de identificador principal asociado a la entidad y puede afectar validaciones o generación posterior de datos.',
    keyingType: 'Determina cómo se espera tratar la información de keying asociada a la entidad.',
    entityKeyVisible: 'Permite mostrar el EntityKey en los resultados cuando se requiere visibilidad operativa o análisis.',
    isHash: 'Indica que la búsqueda debe resolverse usando hash antes de consultar la fuente correspondiente.',
    addEntidad: 'Habilita la opción para crear una nueva entidad cuando la búsqueda no devuelve resultados.',
    isDissociate: 'Permite que desde los flujos posteriores se habiliten acciones de disociación sobre registros relacionados.',
    purposingFilterPayload: 'Permite definir qué datos se envían a la búsqueda por Propósito y qué valores se esperan recuperar en la respuesta.',
    advancedSection: 'La configuración avanzada define campos adicionales de búsqueda que el usuario podrá completar antes de ejecutar la consulta.',
    advancedName: 'Nombre interno del atributo que se utilizará en la búsqueda.',
    advancedLabel: 'Texto visible que se mostrará al usuario para este campo de búsqueda.',
    advancedType: 'Tipo de dato esperado para el campo de búsqueda.',
    advancedOrder: 'Posición del campo dentro del formulario de búsqueda avanzada.',
    advancedVisible: 'Define si el campo se mostrará al usuario como criterio de búsqueda.',
    advancedRequired: 'Indica si el usuario debe completar este campo para poder buscar.',
    identifiersSection: 'Los identificadores complementan la búsqueda con valores visibles, automáticos o fijos que viajan junto a la consulta.',
    identifierName: 'Nombre interno del identificador que se enviará en la consulta.',
    identifierLabel: 'Texto visible para el usuario cuando el identificador forma parte del formulario.',
    identifierType: 'Tipo de dato esperado para el identificador.',
    identifierOrder: 'Posición del identificador dentro del bloque de búsqueda.',
    identifierVisible: 'Define si el identificador será ingresado por el usuario o si viajará de forma oculta.',
    identifierTypeValue: 'Indica si el valor vendrá desde el input, desde el país seleccionado o desde un valor fijo.',
    identifierValue: 'Valor fijo o automático que se enviará cuando el identificador no dependa del ingreso manual del usuario.',
    identifierRequired: 'Indica si este identificador visible debe completarse para poder ejecutar la búsqueda.',
  };

  private _data: any;
  form: FormGroup;

  tableConfig: any[] = [];


  @Input() domainListInput: IDomainVerify[] = [];
  availableDomains: string[] = [];
  availableSubDomains: string[] = [];

  filteredDomains!: Observable<string[]>;
  filteredSubDomains!: Observable<string[]>;

  @Input() showModal: boolean = false;
  @Input() title: string = '';

  @Input() data: any;
  @Input() configNames: string[] = [];

  @Output() onCloseModal: EventEmitter<any> = new EventEmitter();
  @Output() onSaveModal: EventEmitter<any> = new EventEmitter();

  requiredOptions = [
    { label: 'Sí', value: true },
    { label: 'No', value: false }
  ];

  @Input() inData = [];
  @Input() flowTableModal: EnumAbmBuscadorFlow;
  @Input() inStructModal: ITableSearchConfig[];
  get OptionsFlowTable(): typeof EnumAbmBuscadorFlow {
    return EnumAbmBuscadorFlow;
  }


  get regionSelecionada(): Country {
    return this.localStorageService.getRegionSeleccionada;
  }


  @Input() tabletModal = [];
  selectedTabIndex: number = 0;
  isVisibleTabEnabled: boolean = false;
  isExpandedAdvancedSettings: boolean = false;
  isExpandedIdentifiersSettings: boolean = false;


  constructor(
    private formBuilder: FormBuilder,
    private localStorageService: LocalStorageService,
  ) {
    this.initForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('Domain List Input:', this.domainListInput);
    this.tableConfig = [];
    if (this.domainListInput) {
      this.availableDomains = this.domainListInput.map(d => d.domain);
    }

    if (this.domainListInput && changes['domainListInput']) {
      this.availableDomains = this.domainListInput.map(d => d.domain);
      this.setupDomainFilter();
    }

    if (changes['tabletModal'] && this.tabletModal) {
      this.tableConfig = [...this.tabletModal];
      console.log('tableConfig inicializado con datos existentes:', this.tableConfig);
    }


    this.form.get('domain')?.valueChanges.subscribe((selectedDomain) => {
      this.updateSubDomainsList(selectedDomain);
    });
    if (changes['data'] && this.data) {
      console.log('Data changed:', this.data);
      this.updateFormState(this.data);
    }
    this.isVisibleTabEnabled = this.title === 'Agregar Nuevo Buscador' ? false : true;
  }

  ngOnInit() {
    this.setupDomainFilter();
    this.setupSubDomainFilter();
    this.setupSourceTypeBehavior();

    this.form.get('domain')?.valueChanges.subscribe((value) => {
      this.handleDomainChangeLogic(value);
    });
  }

  private setupSourceTypeBehavior() {
    const sourceTypeControl = this.form.get('searchSourceType');

    this.applySourceTypeValidators(sourceTypeControl?.value || 'JOURNALING');
    sourceTypeControl?.valueChanges.subscribe((value: string) => this.applySourceTypeValidators(value || 'JOURNALING'));
  }

  private applySourceTypeValidators(sourceType: string): void {
    const domainControl = this.form.get('domain');
    const subDomainControl = this.form.get('subDomain');
    const purposingProfileControl = this.form.get('purposingProfile');

    const isPurposing = sourceType === 'PURPOSING';

    if (isPurposing) {
      domainControl?.setValidators([Validators.required]);
      subDomainControl?.clearValidators();
      purposingProfileControl?.setValidators([Validators.required]);
    } else {
      domainControl?.setValidators([Validators.required]);
      subDomainControl?.setValidators([Validators.required]);
      purposingProfileControl?.clearValidators();
      purposingProfileControl?.setValue('', { emitEvent: false });
    }

    domainControl?.updateValueAndValidity({ emitEvent: false });
    subDomainControl?.updateValueAndValidity({ emitEvent: false });
    purposingProfileControl?.updateValueAndValidity({ emitEvent: false });
  }


  getFormGroup(index: number): FormGroup {
    return this.configAvanced.at(index) as FormGroup;
  }

  setupDomainFilter() {
    this.filteredDomains = this.form.get('domain')!.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '', this.availableDomains))
    );
  }



  setupSubDomainFilter() {
    this.filteredSubDomains = this.form.get('subDomain')!.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '', this.availableSubDomains))
    );


  }

  private _filter(value: string, options: string[]): string[] {
    const filterValue = value.toLowerCase();
    return options.filter(option => option.toLowerCase().includes(filterValue));
  }


  handleDomainChangeLogic(domainValue: string) {

    const domainObj = this.domainListInput.find(d => d.domain === domainValue);

    if (domainObj) {

      this.availableSubDomains = domainObj.subdomains;
    } else {

      this.availableSubDomains = [];
    }


    const currentSub = this.form.get('subDomain')?.value;
    if (currentSub && !this.availableSubDomains.includes(currentSub)) {
      this.form.get('subDomain')?.setValue('', { emitEvent: false });
    }


    this.setupSubDomainFilter();

  }


  isValidDomain(value: string): boolean {
    return this.availableDomains.includes(value);
  }


  updateSubDomainsList(domain: string) {
    const domainObj = this.domainListInput.find(d => d.domain === domain);
    this.availableSubDomains = domainObj ? domainObj.subdomains : [];


    const currentSub = this.form.get('subDomain')?.value;
    if (currentSub && !this.availableSubDomains.includes(currentSub)) {
      this.form.get('subDomain')?.setValue('');
    }
  }

  private updateFormState(incomingData: any) {
    console.log('updateFormState Datos entrantes:', incomingData);
    if (!this.form) return;

    const patchObject: any = {};


    if (incomingData.inputs?.length) {
      incomingData.inputs.forEach((item: any) => {
        if (item.nameService) {
          patchObject[item.nameService] = item.value;
        }
      });
    }

    if (incomingData.checkboxs?.length) {
      incomingData.checkboxs.forEach((item: any) => {
        if (item.nameService) {
          patchObject[item.nameService] = item.value;
        }
      });
    }

    if (incomingData.configAvanced?.length) {
      this.isExpandedAdvancedSettings = incomingData.configAvanced?.length > 0 ? true : false;
      incomingData.configAvanced?.forEach((item: any) => {
        this.addConfigAvanced(item);
      });
    }


    if (incomingData.identifiers?.length) {
      this.isExpandedIdentifiersSettings = incomingData.identifiers?.length > 0 ? true : false;
      incomingData.identifiers.forEach((item: any) => {
        this.addIdentifiers(item);
      });
    }

    ['searchSourceType', 'purposingProfile'].forEach((fieldName) => {
      if (incomingData[fieldName] !== undefined) {
        patchObject[fieldName] = incomingData[fieldName];
      }
    });

    const hasResponseValues = incomingData.purposingFilterPayload !== undefined;
    if (hasResponseValues) {
      patchObject.purposingFilterPayload = this.formatPurposingPayload(incomingData.purposingFilterPayload);
    } else if (incomingData.responseValues !== undefined) {
      patchObject.purposingFilterPayload = this.formatPurposingPayload(incomingData.responseValues || {});
    }

    const domainValue = patchObject['domain'];

    if (domainValue) {

      const domainObj = this.domainListInput.find(d => d.domain === domainValue);


      this.availableSubDomains = domainObj ? domainObj.subdomains : [];
    }


    this.form.patchValue(patchObject, { emitEvent: false });

    const currentSourceType = patchObject.searchSourceType || this.form.get('searchSourceType')?.value || 'JOURNALING';
    this.applySourceTypeValidators(currentSourceType);
  }


  get configAvanced(): FormArray { return this.form.get('configAvanced') as FormArray; }

  initConfigAvanced(data: any = {}) {
    return new FormGroup({
      "name": new FormControl(data.name || ''),
      "label": new FormControl(data.label || ''),
      "type": new FormControl(data.type || ''),
      "value": new FormControl(data.value || null),
      "required": new FormControl(data.required || false),
      "visible": new FormControl(data.visible || false),
      "order": new FormControl(data.order || 0),
    });
  }

  addConfigAvanced(data?: any) {
    const group = this.initConfigAvanced(data);

    this.setupNameBehavior(group);

    this.configAvanced.push(group);
  }

  deleteConfigAvanced(i: number) {
    this.configAvanced.removeAt(i);
  }




  get identifiers(): FormArray { return this.form.get('identifiers') as FormArray; }
  initIdentifiers(data: any = {}) {

    console.log("initIdentifiers data:", data);
    return new FormGroup({
      "name": new FormControl(data.name || ''),
      "label": new FormControl(data.label || ''),
      "type": new FormControl(data.type || ''),
      "typeValue": new FormControl(data.typeValue || ''),
      "value": new FormControl(data.value !== undefined ? data.value : null),
      "required": new FormControl(data.required === true || data.required === 'true'),
      "visible": new FormControl(data.visible === true || data.visible === 'true'),
      "order": new FormControl(data.order || 0),
    });
  }



  addIdentifiers(data?: any) {
    const group = this.initIdentifiers(data);

    console.log("addIdentifiers group:", group);

    this.setupIdentifierValueChanges(group);

    this.setupNameBehavior(group);

    this.identifiers.push(group);
  }

  deleteIdentifiers(i: number) {
    this.identifiers.removeAt(i);
  }


  setupNameBehavior(group: FormGroup) {
    const nameControl = group.get('name');
    const value = group.get('value');

    nameControl?.valueChanges.subscribe((val: string) => {
      if (!val) return;
      const formatted = val.replace(/\s+/g, '_');
      if (val !== formatted) {
        nameControl.setValue(formatted, { emitEvent: false });
      }

    });
  }


  setupIdentifierValueChanges(group: FormGroup) {
    const typeValueControl = group.get('typeValue');
    const valueControl = group.get('value');

    typeValueControl?.valueChanges.subscribe((selectedType: string) => {

      if (!this.regionSelecionada) return;

      switch (selectedType) {
        case 'countryCode':
          valueControl?.setValue(this.regionSelecionada.getCode().toUpperCase() || '');
          break;

        case 'countryName':

          valueControl?.setValue(this.regionSelecionada.getName().toUpperCase() || '');
          break;

        case '':

          valueControl?.setValue('');
          break;

        default:

          valueControl?.setValue(null);
          break;
      }
    });
  }

  initForm() {
    const configName = this.configNames.length > 0 ? this.configNames[0] : '';
    this.form = this.formBuilder.group({
      id: [''],
      domain: ['', Validators.required],
      subDomain: ['', Validators.required],
      searchSourceType: ['JOURNALING'],
      purposingProfile: [''],
      purposingFilterPayload: [this.defaultPurposingPayload],
      order: [],
      labelDropDown: ["", Validators.required],
      profile: [""],
      profileBusqueda: [""],
      typeNumber: [""],
      keyingType: [""],
      identifyType: [""],
      isHash: [false],
      entityKeyVisible: [false],
      addEntidad: [false],
      isDissociate: [false],
      configAvanced: new FormArray([]),
      configName: [configName],
      identifiers: new FormArray([])
    });
  }

  onSubmit() {
    console.log("onSubmit Formulario enviado con valor:", this.form.value);
    console.log("onSubmit Formulario válido:", this.form.valid);
    console.log("onSubmit tabletModal", this.tabletModal);
    console.log("onSubmit this.tableConfig", this.tableConfig);

    if (this.form.valid) {
      this.form.markAllAsTouched();
      console.log("onSubmit fin", this.form.value);

      const visibleTableConfig = this.tableConfig.filter(item => item.visible === true);

      const value = {
        ...this.form.value,
        tableConfig: visibleTableConfig
      };

      // Regenerar purposingFilterPayload para PURPOSING basado en la tabla configurada
      if (value.searchSourceType === 'PURPOSING' && visibleTableConfig.length > 0) {
        const generatedResponseValues = this.buildResponseValuesFromTableConfig(visibleTableConfig);

        value.purposingFilterPayload = this.formatPurposingPayload(generatedResponseValues);
        delete value.responseValues;

        console.log("onSubmit purposingFilterPayload generado:", value.purposingFilterPayload);
      }

      console.log("onSubmit valor a emitir:", value);
      this.clearForm();
      this.onSaveModal.emit(value);
      return;
    }

  }

  private buildResponseValuesFromTableConfig(tableConfig: ITableSearchConfig[]): Record<string, any> {
    const responseValues: Record<string, any> = {};

    tableConfig.forEach((config) => {
      const varName = config.varName || '';

      if (!varName || varName === 'entityKey') {
        return;
      }

      // Parsear estructura: "accounts[].transactions[].stdAccountOpeningDate"
      // Resultado esperado: [
      //   { type: 'key', name: 'accounts' },
      //   { type: 'array' },
      //   { type: 'key', name: 'transactions' },
      //   { type: 'array' },
      //   { type: 'key', name: 'stdAccountOpeningDate' }
      // ]
      const segments = this.parsePathSegments(varName);

      if (segments.length === 1 && segments[0].type === 'key' && segments[0].name) {
        // Campo simple
        responseValues[segments[0].name] = true;
      } else {
        // Estructura con arrays: mergear en responseValues
        this.mergeStructureIntoResponseValues(responseValues, segments);
      }
    });

    return responseValues;
  }

  private parsePathSegments(varName: string): Array<{ type: 'key' | 'array'; name?: string }> {
    const segments: Array<{ type: 'key' | 'array'; name?: string }> = [];
    const regex = /([a-zA-Z_][a-zA-Z0-9_]*)|(\[\])/g;
    let match;

    while ((match = regex.exec(varName)) !== null) {
      if (match[1]) {
        // Matched a key
        segments.push({ type: 'key', name: match[1] });
      } else if (match[2]) {
        // Matched []
        segments.push({ type: 'array' });
      }
    }

    return segments;
  }

  private mergeStructureIntoResponseValues(target: Record<string, any>, segments: Array<{ type: 'key' | 'array'; name?: string }>): void {
    let current = target;

    for (let i = 0; i < segments.length; i++) {
      const seg = segments[i];
      const nextSeg = segments[i + 1];

      if (seg.type === 'key' && seg.name) {
        const keyName = seg.name;

        if (nextSeg?.type === 'array') {
          // Esta clave es seguida por un array
          if (!current[keyName]) {
            current[keyName] = [{}];
          } else if (!Array.isArray(current[keyName])) {
            current[keyName] = [current[keyName]];
          } else if (current[keyName].length === 0) {
            current[keyName].push({});
          }

          current = current[keyName][0];
          i++; // Saltar el siguiente que es []
        } else {
          // Esta es la última clave o no es seguida por array
          current[keyName] = true;
        }
      }
    }
  }

  closeModal() {
    this.clearForm();
    console.log("this.isVisibleTabEnabled:", this.isVisibleTabEnabled);
    this.onCloseModal.emit(false);
  }

  clearForm() {
    this.form.reset();
    this.tabletModal = [];
    this.configAvanced.clear();
    this.identifiers.clear();
    this.selectedTabIndex = 0;
    this.isExpandedAdvancedSettings = false;
    this.isVisibleTabEnabled = false;
  }

  getControls(key: string) {
    return (this.form.get(key) as FormArray)?.controls || [];
  }

  saveConfigTable(dataTable: any) {
    console.log("saveConfigTable dataTable ---->", dataTable);
    this.tableConfig = dataTable;
  }

  private formatPurposingPayload(value: any): string {
    if (value === undefined || value === null || value === '') {
      return this.defaultPurposingPayload;
    }

    if (typeof value === 'string') {
      try {
        return JSON.stringify(JSON.parse(value), null, 2);
      } catch {
        return value;
      }
    }

    try {
      return JSON.stringify(value, null, 2);
    } catch {
      return this.defaultPurposingPayload;
    }
  }

  formatPurposingPayloadControl(): void {
    const control = this.form.get('purposingFilterPayload');
    if (!control) {
      return;
    }

    const formatted = this.formatPurposingPayload(control.value);
    control.setValue(formatted, { emitEvent: false });
  }

  getHelpText(key: string): string {
    return this.helpTexts[key] || '';
  }
}
